/* HELEN REVIEWS — "Xem thêm" + sắp xếp cho khối đánh giá riêng của Helen (thay Fera). Không thư viện, không gọi máy chủ ngoài Shopify.
 * Trang in sẵn tối đa 24 đánh giá; khi khách bấm "Xem thêm" hết phần in sẵn (tường đánh giá) hoặc đổi cách sắp xếp thì mới tải
 * toàn bộ đánh giá (assets/helen-reviews-all.json, ~90KB nén) 1 lần rồi vẽ thêm 12 cái/lần bấm.
 * Mẫu thẻ ở đây phải giống hệt snippets/helen-review-card.liquid.
 */
(function () {
  'use strict';
  var D = document, STEP = 12, cache = null;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function when(d) { try { return new Date(d + 'T00:00:00Z').toLocaleDateString('en-US', { month: 'short', year: 'numeric', timeZone: 'UTC' }); } catch (e) { return d; } }
  function img(u) { return /cdn\.shopify\.com/.test(u) ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=200' : u; }
  function card(o) {
    var h = '<article class="hr-c"><span class="hr-st" style="--r:' + (+o.r || 0) + '" aria-label="' + (+o.r || 0) + ' out of 5 stars">★★★★★</span>';
    if (o.h) h += '<h3>' + esc(o.h) + '</h3>';
    if (o.b) h += '<p class="hr-b">' + esc(o.b) + '</p>';
    if (o.m && o.m.length) h += '<div class="hr-ph">' + o.m.map(function (u) { return '<a href="' + esc(u) + '" target="_blank" rel="noopener"><img src="' + esc(img(u)) + '" alt="Customer photo" width="96" height="96" loading="lazy" decoding="async"></a>'; }).join('') + '</div>';
    h += '<p class="hr-by"><b>' + esc(o.n) + '</b>' + (o.l ? ' · ' + esc(o.l) : '') + ' · ' + (o.s === 'etsy' ? 'Verified Etsy buyer' : 'Verified buyer') + ' · ' + when(o.d) + '</p>';
    if (o.p) h += '<p class="hr-p">Product: ' + esc(o.p) + '</p>';
    return h + '</article>';
  }
  var SORT = {
    best: function (a) { return a.slice(); }, // file đã xếp sẵn theo "đáng xem nhất"
    new: function (a) { return a.slice().sort(function (x, y) { return x.d < y.d ? 1 : x.d > y.d ? -1 : 0; }); },
    high: function (a) { return a.slice().sort(function (x, y) { return y.r - x.r; }); },
    low: function (a) { return a.slice().sort(function (x, y) { return x.r - y.r; }); },
    photo: function (a) { return a.filter(function (o) { return o.m && o.m.length; }); }
  };
  function loadAll(sec) {
    if (cache) return Promise.resolve(cache);
    return fetch(sec.getAttribute('data-all'), { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (a) { cache = a; return a; });
  }
  function init(sec) {
    var list = sec.querySelector('[data-hr-list]'), more = sec.querySelector('[data-hr-more]'), sel = sec.querySelector('[data-hr-sort]');
    var wall = sec.getAttribute('data-hr') === 'wall', rows = null, shown = 0;
    function draw() {
      list.innerHTML = rows.slice(0, shown).map(card).join('');
      if (more) more.hidden = shown >= rows.length;
    }
    if (more) more.addEventListener('click', function () {
      var hid = list.querySelectorAll('.hr-c[hidden]');
      if (hid.length) { // còn thẻ in sẵn đang ẩn → mở thêm 6
        for (var i = 0; i < hid.length && i < 6; i++) hid[i].hidden = false;
        if (!wall && hid.length <= 6) more.hidden = true;
        return;
      }
      if (!wall) { more.hidden = true; return; }
      more.disabled = true;
      loadAll(sec).then(function (a) {
        if (!rows) { rows = SORT[(sel && sel.value) || 'best'](a); shown = list.querySelectorAll('.hr-c').length; }
        shown += STEP; draw();
      }).catch(function () { more.hidden = true; }).then(function () { more.disabled = false; });
    });
    if (sel) sel.addEventListener('change', function () {
      loadAll(sec).then(function (a) { rows = SORT[sel.value](a); shown = STEP; draw(); });
    });
  }
  function start() { Array.prototype.forEach.call(D.querySelectorAll('[data-hr="wall"],[data-hr="product"]'), function (s) { if (!s.__hr) { s.__hr = 1; init(s); } }); }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', start); else start();
})();
